import { httpClient } from '../core/httpClient';
import { getBalanceUrl } from '../core/endponts';
import { userService } from './helperService/UserService';

class PlayerService {
  constructor() {
    this.timer = null;
  }

  async getBalance() {
    return await httpClient.get(getBalanceUrl()).then(result => {
      userService.updateBalance(result.balance);
      return result.balance;
    });
  }

  async holdUpdateBalance(timeOut = 5000) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.getBalance();
    }, timeOut);
  }

}

export const playerService = new PlayerService();
